"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossIcon = exports.TickIcon = void 0;
const preact_1 = require("preact");
function TickIcon({ className }) {
    return ((0, preact_1.h)("svg", { xmlns: 'http://www.w3.org/2000/svg', className: className, viewBox: '0 0 20 20' },
        (0, preact_1.h)("path", { "fill-rule": 'evenodd', d: 'M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z', "clip-rule": 'evenodd' })));
}
exports.TickIcon = TickIcon;
function CrossIcon({ className }) {
    return ((0, preact_1.h)("svg", { xmlns: 'http://www.w3.org/2000/svg', className: className, viewBox: '0 0 20 20' },
        (0, preact_1.h)("path", { fillRule: 'evenodd', d: 'M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z', clipRule: 'evenodd' })));
}
exports.CrossIcon = CrossIcon;
